import Configuration from './Configuration';

export default function getPreferencesApiRoot() {
  const config = Configuration.Current();
  return `${config.apiRoot}/omni/profile/v2/communications-preferences`;
}
